import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { LandingSubscriptionPage } from "./LandingSubscriptionPage";
import { LoginPage } from "./LoginPage";
import { ResetPasswordPage } from "./ResetPasswordPage";
import { ForgotPasswordPage } from "./ForgotPasswordPage";
import { RegisterPage } from "./RegisterPage";
import { PhonePage } from "./PhonePage";
import { CodePage } from "./CodePage";
import { NamePage } from "./NamePage";
import { ProfilePage } from "./ProfilePage";
import { Provider as ReduxProvider } from "react-redux";
import store from "../../store";
import useUniqueDispatch, {
  isLoading,
  MobileContext,
  useSelector,
} from "../../utils/redux-utils";
import { RootState } from "../../store/root-reducer";
import { createContext, useEffect, useState } from "react";
import { userGetMeAction } from "../../store/user/action";
import { ActivityIndicator, Dimensions, View } from "react-native";
import { SendEmailPage } from "./SendEmailPage";
import { ChatPage } from "./ChatPage";
import { PlacePage } from "../PlacePage";
import { colors } from "../../common/styles/colors";
import { MapPage } from "./MapPage";

const SubscriptionNavigation = () => {
  const token = useSelector((store: RootState) => store.token.data);

  const userRequest = useSelector((store: RootState) => store.user);

  const [getMeToken, getMe] = useUniqueDispatch(userGetMeAction.request);

  const isUserLoading = isLoading(userRequest, getMeToken);

  useEffect(() => {
    if (token && !userRequest.data) {
      getMe([]);
    }
  }, [token]);

  return (
    <View style={{ height: Dimensions.get("window").height }}>
      {isUserLoading ? (
        <ActivityIndicator color={colors.black} style={{ flex: 1 }} />
      ) : userRequest.data?.id ? (
        <MainNavigation />
      ) : (
        <AuthNavigation />
      )}
    </View>
  );
};

export const AuthContext = createContext({
  password: "",
  email: "",
  phone: "",
  setPhone: (v: string) => {},
  setEmail: (v: string) => {},
  setPassword: (v: string) => {},
});

const AuthNavigation = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");

  return (
    <AuthContext.Provider
      value={{
        phone,
        setPhone,
        email,
        password,
        setEmail,
        setPassword,
      }}
    >
      <Routes>
        <Route
          path={"/subscription/welcome"}
          element={<LandingSubscriptionPage />}
        />
        {!(email && password) ? (
          <>
            <Route path={"/subscription/register"} element={<RegisterPage />} />
            <Route path={"/subscription/login"} element={<LoginPage />} />
            <Route
              path={"/subscription/forgot-password"}
              element={<ForgotPasswordPage />}
            />
            <Route
              path={"/subscription/reset-password"}
              element={<ResetPasswordPage />}
            />
          </>
        ) : (
          <>
            <Route path={"/subscription/register"} element={<RegisterPage />} />
            <Route path={"/subscription/phone"} element={<PhonePage />} />
            <Route path={"/subscription/code"} element={<CodePage />} />
            <Route path={"/subscription/login"} element={<LoginPage />} />
            <Route
              path={"/subscription/forgot-password"}
              element={<ForgotPasswordPage />}
            />
          </>
        )}
        <Route
          path="*"
          element={<Navigate replace to="/subscription/welcome" />}
        />
      </Routes>
    </AuthContext.Provider>
  );
};

const MainNavigation = () => {
  const user = useSelector((store: RootState) => store.user.data);

  return (
    <Routes>
      {user.confirmed ? (
        <>
          <Route path={"/subscription/name"} element={<NamePage />} />
          <Route path={"/subscription/chat"} element={<ChatPage />} />
          <Route
            path={"/subscription/chat/place/:placeId"}
            element={<PlacePage fromChat />}
          />
          <Route path={"/subscription/profile"} element={<ProfilePage />} />
          <Route path={"/subscription/map"} element={<MapPage />} />
        </>
      ) : (
        <Route path={"/subscription/confirm"} element={<SendEmailPage />} />
      )}

      <Route
        path="*"
        element={
          <Navigate
            replace
            to={
              !user.confirmed
                ? "/subscription/confirm"
                : user?.first_name && user?.second_name
                ? "/subscription/chat"
                : "/subscription/name"
            }
          />
        }
      />
    </Routes>
  );
};

export const SubscriptionWrapper = () => {
  return (
    <ReduxProvider context={MobileContext} store={store}>
      <SubscriptionNavigation />
    </ReduxProvider>
  );
};
